import AOS from 'aos'
import './navigation.js'

window.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 600,
		once: true,
		offset: 30,
	})

	setTimeout(() => {
		AOS.refresh()
	}, 100)
})
